import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowLeft2Icon = ({ color = 'currentColor', size = 14, ref, ...props }) => {
    return (_jsx("svg", { ...props, width: size, height: size, stroke: color, ref: ref, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M13 4L7 10L13 16", strokeWidth: "1.6" }) }));
};
//# sourceMappingURL=arrow-left2-icon.js.map